export const CDRforSms = (builder) => ({
    CDRforSms: builder.mutation({
        query: ({ search, status, startDate, endDate, sender_type, page, limit }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/smsCdrDetails',
                method: 'GET',
                params: { search, status, startDate, endDate, sender_type, page, limit },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});